export const MetaDataInfo = {
    "home": {
        URL: "https://ipagent.ai/",
        Header: "",
        Title: "IP Agent AI | Agentic AI Platform for Patents",
        Description: "From complexity to clarity — IP Agent AI streamlines your patent workflows.",
        Keywords: "AI patent tools, AI patent drafting platform, AI patent search tool, prior art search AI, patent intelligence AI, AI patent portfolio software, automated patent analysis, AI patent assistant, AI patent quality check, patent error detection AI, patent analytics and AI, AI patent drafting assistant, IP agent AI, best AI patent tools 2025, patent research tools, patent monitoring tool, patent prosecution AI, AI claim drafting, AI copilot for patents",
        URLKeys: "home",
        OGKeyword: "AI patent tools, IP automation, patent drafting",
        OGTitle: "IP Agent AI – Agentic AI Platform for Patents"
    },
    "ai-ip-use-cases": {
        URL: "https://ipagent.ai/ai-ip-use-cases",
        Header: "AI-Powered IP Use Cases",
        Title: "AI-Powered IP Use Cases – IP Agent AI",
        Description: "From complexity to clarity — IP Agent AI streamlines IP workflows with AI-powered solutions for patents, trademarks, claim charts, invalidity searches, first drafts, office action responses, freedom-to-operate analysis, trade secrets, and more.",
        Keywords: "patent drafting AI, prior art search AI, AI patent search software, IP translations, AI claim charts, invalidity searches AI, Inventor AI Assist, patentability validation AI, office action response AI, freedom to operate AI, IP workflows automation, trade secrets AI, patent proofreading AI, patent categorization AI, patent error detection AI, AI prior art analyzer, AI patent analytics platform, patent collaboration tool, AI summarization prior art comparison",
        URLKeys: "ai-ip-use-cases",
        OGTitle: "AI-Powered IP Workflows & Use Cases – IP Agent AI",

    },
    "pricing": {
        URL: "https://ipagent.ai/pricing",
        Header: "",
        Title: "Pricing – IP Agent AI",
        Description: "Choose from flexible subscription plans for IP Agent AI’s platform. Scale your patent workflows with transparent pricing tailored to professionals, law firms, and enterprises.",
        Keywords: "AI patent assistant cost, IP Agent AI pricing, AI patent drafting tool price, patent analysis AI cost, patent drafting subscription, patent search AI software pricing, IP software subscription, AI tools ranked for patent professionals, AI copilot pricing, IP portfolio management AI cost, enterprise patent AI plans, law firm AI subscription, patent automation pricing",
        URLKeys: "pricing",
        OGKeyword: "AI patent tool pricing, subscription",
        OGTitle: "IP Agent AI Pricing Plans"
    },
    "company": {
        URL: "https://ipagent.ai/company",
        Header: "Company",
        Title: "About IP Agent AI – Company Vision & Mission",
        Description: "Learn about IP Agent AI’s mission to revolutionize intellectual property with Agentic AI-powered solutions. Discover our vision, mission, and values shaping the future of IP professionals.",
        Keywords: "IP Agent AI company, AI for intellectual property, agentic AI innovation, patent drafting AI company, patent automation platform, IP portfolio AI solutions, legaltech AI, IP agent company values, patent workflow AI, IP law firm AI partner, AI IP management platform, innovation in IP AI, IP professional AI assistant, AI IP revolution, IP software leadership",
        URLKeys: "company",
        OGKeyword: "AI IP innovation, IP Agent AI company",
        OGTitle: "About IP Agent AI"
    },
    "blogs": {
        URL: "https://ipagent.ai/blogs",
        Header: "",
        Title: "IP Agent AI Blog – Insights on AI & Intellectual Property",
        Description: "Read expert articles, insights, and updates from IP Agent AI on AI-powered patent tools, prior art search, drafting efficiency, and the future of intellectual property.",
        Keywords: "AI patent blog, patent analytics blog, IP research articles, AI intellectual property insights, patent prosecution AI updates, patent drafting efficiency blog, generative AI for patents, best AI patent tools 2025 blog, intellectual property AI trends, law firm AI blog, patent automation insights, office action response AI blog, IP portfolio management AI blog",
        URLKeys: "blogs",
        OGKeyword: "AI IP blog, patent insights",
        OGTitle: "IP Agent AI Blog"
    },
    "terms-and-conditions": {
        URL: "https://ipagent.ai/terms-and-conditions",
        Header: "",
        Title: "Terms and Conditions – IP Agent AI",
        Description: "Review the terms and conditions governing the use of IP Agent AI’s services, tools, and website.",
        Keywords: "IP Agent AI terms, AI patent assistant terms, intellectual property software terms, user agreement IP Agent AI, patent drafting tool terms of use, compliance patent AI, AI platform license terms, legal conditions IP software, patent AI user policy",
        URLKeys: "terms-and-conditions",
        OGKeyword: "IP Agent AI terms, user agreement",
        OGTitle: "IP Agent AI Terms and Conditions"
    },
    "privacy-policy": {
        URL: "https://ipagent.ai/privacy-policy",
        Header: "",
        Title: "Privacy Policy – IP Agent AI",
        Description: "Understand how IP Agent AI protects your privacy and handles data securely across all AI-powered IP workflows.",
        Keywords: "IP Agent AI privacy policy, AI patent tool privacy, intellectual property AI data protection, GDPR patent AI compliance, personal data AI software, patent assistant privacy practices, user privacy IP tools, secure patent AI data, AI IP confidentiality",
        URLKeys: "privacy-policy",
        OGKeyword: "privacy, data protection, GDPR compliance",
        OGTitle: "IP Agent AI Privacy Policy"
    },
    404: {
        URL: "https://ipagent.ai/404",
        Header: "",
        Title: "404 – Page Not Found | IP Agent AI",
        Description: "Sorry, this page does not exist. Return to IP Agent AI’s homepage to explore AI-powered patent and IP tools.",
        Keywords: "404 error IP Agent AI, page not found, broken link IP Agent AI, invalid URL patent AI site, missing page IP Agent AI",
        URLKeys: "404",
        OGKeyword: "404 error, page not found",
        OGTitle: "404 - Page Not Found"
    },
    Security: {
        URL: "https://ipagent.ai/security",
        Header: "Security",
        Title: "Trust Center | IP Agent AI",
        Description: "IP Agent AI Trust Center",
        Keywords: "Security, Trust Center, IP Agent AI Security, IP Agent AI Trust Center",
        URLKeys: "security",
        OGKeyword: "security, trust center",
        OGTitle: "IP Agent AI Trust Center | Security"
    },
    request_early_access: {
        URL: "https://ipagent.ai/request_early_access",
        Header: "Early Access Request",
        Title: "Early Access Request | IP Agent AI",
        Description: "Early Access Request",
        Keywords: "Early Access Request, IP Agent AI",
        URLKeys: "request_early_access",
        OGKeyword: "Early Access Request",
        OGTitle: "Early Access Request"
    },
};



